/*
 * Public API Surface of @filevault/components
 */

// Models
export * from './lib/models/file-vault.models';

// Services
export * from './lib/services/file-vault-api.service';

// Components
export { FileExplorerComponent } from './lib/components/file-explorer/file-explorer.component';
export type { ExplorerNode } from './lib/components/file-explorer/file-explorer.component';

export { FileListComponent } from './lib/components/file-list/file-list.component';
export type { ListFileAction } from './lib/components/file-list/file-list.component';

export { FileUploadComponent } from './lib/components/file-upload/file-upload.component';
export type { UploadItem, UploadMode, ImageSlot } from './lib/components/file-upload/file-upload.component';

export { FileViewerComponent } from './lib/components/file-viewer/file-viewer.component';
export type { ViewerMode } from './lib/components/file-viewer/file-viewer.component';

export * from './lib/components/version-history/version-history.component';
export { DrawingNumberRequestComponent } from './lib/components/drawing-number-request/drawing-number-request.component';
export { DrawingNumberListComponent } from './lib/components/drawing-number-list/drawing-number-list.component';

// Lifecycle Components
export { LifecycleBadgeComponent } from './lib/components/lifecycle-badge/lifecycle-badge.component';
export type { LifecycleStateConfig } from './lib/components/lifecycle-badge/lifecycle-badge.component';

export { LifecycleActionsComponent } from './lib/components/lifecycle-actions/lifecycle-actions.component';
export type { TransitionEvent } from './lib/components/lifecycle-actions/lifecycle-actions.component';

export { LifecycleHistoryComponent } from './lib/components/lifecycle-history/lifecycle-history.component';
export type { HistoryViewMode } from './lib/components/lifecycle-history/lifecycle-history.component';

// BOM Components
export { BomTreeComponent } from './lib/components/bom-tree/bom-tree.component';
export type { BomViewMode, BomTreeSelectionEvent } from './lib/components/bom-tree/bom-tree.component';

export { BomEditorComponent } from './lib/components/bom-editor/bom-editor.component';
export type { BomChangeEvent } from './lib/components/bom-editor/bom-editor.component';

export { WhereUsedComponent } from './lib/components/where-used/where-used.component';
export type { WhereUsedViewMode, WhereUsedSelectionEvent } from './lib/components/where-used/where-used.component';

export { BomCompareComponent } from './lib/components/bom-compare/bom-compare.component';
export type { CompareSelection } from './lib/components/bom-compare/bom-compare.component';

// Document Links Components
export { DocumentLinksComponent } from './lib/components/document-links/document-links.component';
export type { DocumentLinkActionEvent, AddDocumentLinkEvent } from './lib/components/document-links/document-links.component';

// Change Management Components
export { ChangeListComponent } from './lib/components/change-list/change-list.component';
export type { ChangeListAction } from './lib/components/change-list/change-list.component';

export { ChangeDetailComponent } from './lib/components/change-detail/change-detail.component';
export type { ChangeDetailEvent } from './lib/components/change-detail/change-detail.component';

export { ChangeCreateComponent } from './lib/components/change-create/change-create.component';
export type { ChangeFormData } from './lib/components/change-create/change-create.component';

export { AffectedItemsComponent } from './lib/components/affected-items/affected-items.component';
export type { AffectedItemsChangeEvent } from './lib/components/affected-items/affected-items.component';

export { ChangeWorkflowComponent } from './lib/components/change-workflow/change-workflow.component';
export type { ChangeWorkflowStepEvent } from './lib/components/change-workflow/change-workflow.component';

export { ChangeDashboardComponent } from './lib/components/change-dashboard/change-dashboard.component';
export type { DashboardClickEvent } from './lib/components/change-dashboard/change-dashboard.component';

// Workflow Components
export { MyTasksComponent } from './lib/components/my-tasks/my-tasks.component';
export type { TaskAction } from './lib/components/my-tasks/my-tasks.component';

export { TaskDetailComponent } from './lib/components/task-detail/task-detail.component';
export type { TaskActionResult } from './lib/components/task-detail/task-detail.component';

export { WorkflowVisualizerComponent } from './lib/components/workflow-visualizer/workflow-visualizer.component';
export type { WorkflowStepClickEvent } from './lib/components/workflow-visualizer/workflow-visualizer.component';

export { WorkflowHistoryComponent } from './lib/components/workflow-history/workflow-history.component';
export { WorkflowTemplateAdminComponent } from './lib/components/workflow-template-admin/workflow-template-admin.component';
export { UserRoleAdminComponent } from './lib/components/user-role-admin/user-role-admin.component';

// Notification Components
export { NotificationCenterComponent } from './lib/components/notification-center/notification-center.component';
export type { NotificationClickEvent } from './lib/components/notification-center/notification-center.component';

export { NotificationPreferencesComponent } from './lib/components/notification-preferences/notification-preferences.component';

// Search Components
export { SearchBarComponent } from './lib/components/search-bar/search-bar.component';
export type { SearchBarAction } from './lib/components/search-bar/search-bar.component';

export { SearchResultsComponent } from './lib/components/search-results/search-results.component';
export type { SearchResultAction } from './lib/components/search-results/search-results.component';

export { SearchFiltersComponent } from './lib/components/search-filters/search-filters.component';
export type { FilterChangeEvent } from './lib/components/search-filters/search-filters.component';

export { SavedSearchesComponent } from './lib/components/saved-searches/saved-searches.component';
export type { SavedSearchAction } from './lib/components/saved-searches/saved-searches.component';
